export default __webpack_public_path__ + "static/media/loading.df531733.svg";